import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCurrencyConversionProfile from 'lumen/components/settings/currency-conversion/profile';
import type MarketSettingsCurrencyConversionProfileController from 'lumen/controllers/market/settings/currency-conversion/profile';
import type MarketSettingsCurrencyConversionProfileRoute from 'lumen/routes/market/settings/currency-conversion/profile';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSettingsCurrencyConversionProfileSignature {
  Args: {
    controller: MarketSettingsCurrencyConversionProfileController;
    model: ModelFrom<MarketSettingsCurrencyConversionProfileRoute>;
  };
}

const MarketSettingsCurrencyConversionProfile: TOC<MarketSettingsCurrencyConversionProfileSignature> =
  <template>
    {{#if @model.exchangeRatesProfile.isRunning}}
      <PrismLoadingBar />
    {{else}}
      <SettingsCurrencyConversionProfile
        @baseCurrencies={{or @model.baseCurrencies.last.value (array)}}
        @exchangeRatesProfile={{@controller.exchangeRatesProfile}}
        @isLoading={{@model.exchangeRatesProfile.isRunning}}
        @isReadOnly={{@controller.isReadOnly}}
      />
    {{/if}}
  </template>;

export default MarketSettingsCurrencyConversionProfile;
